<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content">
      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Add a new Announcement</p>
          <button
            class="delete"
            aria-label="close"
            @click.prevent="close(true)">
          </button>
        </header>

        <v-form class="modal-card-body" :valid.sync="valid">
          <div class="field">
            <label class="label">Message*</label>
            <v-rich-text
              required
              placeholder="Enter Your Message"
              v-model="announcement.message">
            </v-rich-text>
          </div>
          <div class="field">
            <label class="label">Add An Image</label>
            <v-drop-zone 
              id="announcement-image"
              v-model="upload.file"
              :file-name.sync="upload.name"
              height="120px"/>
          </div>
        </v-form>

        <footer class="modal-card-foot">
          <button 
            :disabled="!valid || saving"
            class="button is-primary" 
            :class="{ 'is-loading': saving }"
            @click.stop="addNewAnnouncement()">
            Save
          </button>
          <button 
            class="button" 
            @click.stop="close(true)">
            Cancel
          </button>
        </footer>

      </div>
    </div>
  </div>
</template>

<script>
import VForm from '@/components/base/VForm'
import VRichText from '@/components/base/VRichText'
import VDropZone from '@/components/base/VDropZone'

import { mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean
    }
  },
  components: { VRichText, VDropZone, VForm },
  data() {
    return {
      announcement: {
        message: '',
      },
      upload: {
        file: null,
        name: null,
        url: null
      },
      valid: false,
      saving: false
    }
  },
  methods: {
    ...mapActions("announcements", [
      "addAnnouncement", "saveAnnouncementImage"
    ]),
    addNewAnnouncement() {
      this.saving = true;
      this.addAnnouncement(this.announcement).then(resp => {
        if (this.upload.file) {
          const { upload } = this;
          let formData = new FormData();
          formData.append('images', upload.file, upload.file.name);
          this.saveAnnouncementImage(
            { announcementId: resp.data.id, data: formData }
          ).then(() => {
            this.saving = false;
            this.close(true);
          }).catch(() => this.saving = false)
        } else {
          this.saving = false;
          this.close(true);
        }
      }).catch(() => this.saving = false)
    },
    close(clear=false) {
      this.$emit('input', false);
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>